import OpenPost from './open-post';

export default OpenPost;
